import { TranslateService } from '@ngx-translate/core';
//import { Observable } from 'rxjs/Observable';

import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { BufferChangeHistory } from 'app/buffer-graph/models/buffer-change-history/buffer-change-history';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {Moment} from "moment";
import {ItemInfo} from "../item-info";

type Data = { changes: BufferChangeHistory[], sku: string, warehouseCode: string, canSend: boolean, columns: ColumnSettingsBase[], isAll?: boolean };

export class BufferChangeHistoryTabInfo extends TabInfoBase<Data> {
    constructor(type: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super('BufferChangeHistory', type, data, itemInfo, startDate, endDate, sharedGuid);

    }

    get id(): string {
        return BufferChangeHistoryTabInfo.id;
    }

    static readonly id = 'BCH';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/buffer-change-history/buffer-change-history-tab-info.ts